import styled from 'styled-components'
import BaseButton from '../BaseButton'

const PrimaryButton = styled(BaseButton)`
  color: ${props =>
    props.disabled || props.fakeDisabled
      ? 'var(--color-sw-20)'
      : 'var(--color-white)'};
  border: none;
  background: ${props =>
    props.disabled || props.fakeDisabled
      ? 'var(--color-sw-10)'
      : 'var(--color-brand-red)'};

  :focus-visible,
  :hover {
    background: ${props =>
      props.disabled || props.fakeDisabled
        ? 'var(--color-sw-10)'
        : 'var(--color-brand-red-hover)'};
  }
`

export default PrimaryButton
